import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsGithub } from "react-icons/bs";
import { Link } from "react-router-dom";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">

      {/* VIDEO OR IMAGE */}
      {props.showVideo && props.vimeoId ? (
        <div
          className="video-wrapper"
          style={{
            position: "relative",
            width: "100%",
            paddingTop: "56.25%",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <iframe
            src={`https://player.vimeo.com/video/${props.vimeoId}?badge=0&autopause=0&muted=1&background=1`}
            title="project-video"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            }}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          ></iframe>
        </div>
      ) : (
        <div className="image-wrapper">
          <img src={props.imgPath} alt="card-img" className="image-content" />
        </div>
      )}

      {/* BODY */}
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>

        <Card.Text
          className="inter-text"
          style={{ textAlign: "left", whiteSpace: "pre-line" }}
        >
          {props.description}
        </Card.Text>

        {/* GITHUB BUTTON */}
        {props.ghLink && (
          <Button
            variant="primary"
            className="project-btn"
            href={props.ghLink}
            target="_blank"
          >
            <BsGithub /> GITHUB
          </Button>
        )}

        {/* INTERNAL ROUTE BUTTON */}
        {props.viewRoute && (
          <Button variant="primary" className="project-btn" as={Link} to={props.viewRoute}>
            VIEW
          </Button>
        )}

        {/* CONTACT BUTTON */}
        {props.onContact && (
          <Button
            variant="primary"
            className="project-btn"
            onClick={props.onContact}
          >
            {props.contactText || "MESSAGE ME FOR MORE DETAILS"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
